import { createContext } from "react";

import {
  DiscountProgressBarContextType,
  DiscountQuantityWidgetContext,
  MessageBoxContextType,
} from "@intelligems/ig-types";

export const DiscountProgressBarContext =
  // @ts-ignore
  createContext<DiscountProgressBarContextType>();

export const DiscountMessageBoxContext =
  // @ts-ignore
  createContext<MessageBoxContextType>();

export const DiscountQuantityContext =
  // @ts-ignore
  createContext<DiscountQuantityWidgetContext>();
